/* The code is defining an enum called `AUTH` with two members: `LOGOUT` and `CHANGE_PASSWORD`. Each
member is assigned a string value: `'logout'` and `'change-password'` respectively. The `export`
keyword is used to make the enum accessible outside of the current module. */
export enum AUTH {
    LOGOUT = 'logout',
    CHANGE_PASSWORD = 'change-password'
}
